import { FlashMessageService } from "zoox-infra";
import { zPayRegisterClientForm } from "zoox-components";
import PersonService from "@/service/person-service";

export default {
  name: "CreateCustomerDialog",
  components: {
    "z-pay-register-client-form": zPayRegisterClientForm
  },
  props: {
    openDialog: {
      type: Boolean
    },
    companyName: {
      type: String
    },
    person: {
      type: Object
    },
    companyParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      success: false,
      personService: new PersonService()
    };
  },
  mounted() {
    // REMOVE A CLASSE P/ CORRIGIR O TEMA DE CORES DINÂMICAS DO BOTÃO
    // IMPORTANTE: FORA INSERIDO POR ALGUEM ESTA CLASSE "ORANGEBTN", E ELA ESTILIZA O BOTÃO NO CP-MOBILE
    // POR CONTA DISTO ESTAVA SOBREPONDO O TEMA DO PORTAL.. É GAMBIARRA, MAS FAZER O QUE NÉ?
    document
      .getElementById("zPayRegisterClientSubmitForm")
      .classList.remove("orangeBtn");
  },
  methods: {
    close() {
      this.$emit("closeCustomerDialog");
    },
    async register(person) {
      this.personService
        .register(person)
        .then(async resp => {
          if (resp && resp.id) {
            FlashMessageService.success(
              this.$t("REGISTRATION.COMPLETE_MESSAGE")
            );
            this.$emit("successCustomerDialog");
          }
        })
        .catch(err => {
          if (err.status === 409) {
            FlashMessageService.error(
              this.$t("REGISTRATION.PERSON_ALREADY_EXISTING")
            );
          }
        });
    }
  }
};
